import script from "./LoadWaitSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadWaitSpinner.vue?vue&type=script&setup=true&lang=ts"

import "./LoadWaitSpinner.vue?vue&type=style&index=0&id=c0c9a214&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0c9a214"]])

export default __exports__